import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { MenuItem, TextField } from "@mui/material";
import { editRefundDetails } from "../../../../../services/refundService/model/refundRequest/RefundRequestSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { RefundLocked } from "../../../specs/RefundLocked";

function OpenClaimsSelector(){
    const dispatch = useAppDispatch();
    const refund = useAppSelector((state)=>state.refundRequest.refundRequest);
    return <React.Fragment>
        <TextField label='Open Claims' sx={{width:'225px'}} select
            value={refund.refundDetail.openClaims}
            disabled={new RefundLocked().IsSatisfiedBy(refund)}
            onChange={(e)=>dispatch(editRefundDetails(new ReduxUpdate('openClaims',e.target.value)))}>
                <MenuItem value={false as any}>No</MenuItem>
                <MenuItem value={true as any}>Yes</MenuItem>
            </TextField>
    </React.Fragment>
}

export {OpenClaimsSelector}